import { getUser } from "@utils";
import React from "react";
import { Content, ContentTitle } from "../baseItems";
import Base from "./base";

export default class PaparaFast extends Base {
	getStep1(translate) {
		return (
			<Content>
				<ContentTitle>{translate("Payment_Stake")}</ContentTitle>
				{this.getCurrencyField(translate)}
				{this.renderMinMax()}
			</Content>
		);
	}

	makeExternalPayment(newStep) {
		this.props.externalFunc.depositPaparaFast(
			{
				return_url: window.location.href,
			},
			(data) => {
				this.setState({
					externalUrl: data.link,
					currentStep: newStep,
				});
			}
		);
	}

	makeExternalPaymentWithBonus(newStep, bonusId) {
		this.props.externalFunc.depositPaparaFast(
			{
				language: this.getActiveLanguageCode(),
				sessionId: getUser().sessionId,
				claimsBonus: true,
				bonusId: bonusId,
			},
			(data) => {
				this.setState({
					externalUrl: data.link,
					currentStep: newStep,
				});
			}
		);
	}
}
